import { jsx as _jsx } from "react/jsx-runtime";
export const ChonkyIconPlaceholder = () => {
    // This component should not be rendered unless the user has misconfigured Chonky
    const title = "No icon component found. Please follow Chonky installation instructions to " +
        "provide a pre-made icon component (or a custom icon).";
    return _jsx("span", Object.assign({ title: title }, { children: "\u26A0\uFE0F" }));
};
